import meswak_logo from "../../assets/dabur/dabur-logo.webp"
import haleon_logo from "../../assets/haleon/parodontax-the-gum-experts-newest-logo 1.png"
import ryzehealth_logo from "../../assets/illustrations/nexus-health-logo.webp"
import toothlens_logo from "../../assets/illustrations/Toothlens_logo.png"
import idealhealth_logo from "../../assets/illustrations/Ideal Health Logo.png"
import frontImage from "../../assets/dabur/front.webp"
import leftImage from "../../assets/dabur/left.webp"
import rightImage from "../../assets/dabur/right.webp"
import nexus_logo from "../../assets/illustrations/nexus oral health tooth logo.png"
import pepsodent_india_logo from "../../assets/pepsodent-india/pepsodent-logo.jpeg"
import pepsodentIndiaFrontImage from "../../assets/pepsodent-india/front.webp"
import pepsodentIndiaLeftImage from "../../assets/pepsodent-india/left.webp"
import pepsodentIndiaRightImage from "../../assets/pepsodent-india/right.webp"
const meswak = {
    colors: {
        primary: '#d1a272',
        secondary: '#707070',
        tertiary: '#1155cc',
        accent: '#337ab7',
        success: '#28a745',
        error: '#dc3545',
        warning: '#ffc107',
        info: '#17a2b8',
        light: '#f8f9fa',
        dark: '#343a40'
    },
    teeth_sides: [0, 1, 2, 3, 4],
    logo: meswak_logo
}

const haleon = {
    colors: {
        primary: '#D50037',
        secondary: '#0B2341',
        tertiary: '#00196C',
        accent: '#337ab7',
        success: '#28a745',
        error: '#dc3545',
        warning: '#ffc107',
        info: '#17a2b8',
        light: '#f8f9fa',
        dark: '#343a40'
    },
    teeth_sides: [0, 1, 2],
    logo: haleon_logo,
    content: {
        landing: {
            description: "Get a gum health score with <br /> three easy snaps.",
            buttonText: "Start"
        },
        demo: {
            front: {
                label: "Front View Example",
                image: frontImage,
                name: "Front teeth",
                helpers: [
                    "Position your front teeth within template",
                    "Keep a small gap between your front teeth"
                ]
            },
            left: {
                label: "Left View Example",
                image: leftImage,
                name: "Left side",
                helpers: [
                    "Pull the corner of your mouth",
                    "Pull your lip back so the gums are visible"
                ]
            },
            right: {
                label: "Right View Example",
                image: rightImage,
                name: "Right side",
                helpers: [
                    "Pull the corner of your mouth",
                    "Pull your lip back so the gums are visible"
                ]
            }
        }
    }
}

const ryzehealth = {
    colors: {
        primary: '#000000',
        secondary: '#6b7280',
        tertiary: '#1f2937',
        accent: '#374151',
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6',
        light: '#f9fafb',
        dark: '#111827',
        purple: '#8b5cf6',
        pink: '#ec4899',
        indigo: '#6366f1',
        teal: '#14b8a6',
        orange: '#f97316',
        cyan: '#06b6d4'
    },
    teeth_sides: [0, 1, 2, 3, 4],
    logo: ryzehealth_logo
}

const idealhealth = {
    colors: {
        primary: '#000000',
        secondary: '#6b7280',
        tertiary: '#1f2937',
        accent: '#374151',
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6',
        light: '#f9fafb',
        dark: '#111827',
        purple: '#8b5cf6',
        pink: '#ec4899',
        indigo: '#6366f1',
        teal: '#14b8a6',
        orange: '#f97316',
        cyan: '#06b6d4'
    },
    teeth_sides: [0, 1, 2, 3, 4],
    logo: idealhealth_logo
}

const toothlens = {
    colors: {
        primary: '#000000',
        secondary: '#6b7280',
        tertiary: '#1f2937',
        accent: '#374151',
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6',
        light: '#f9fafb',
        dark: '#111827',
        purple: '#8b5cf6',
        pink: '#ec4899',
        indigo: '#6366f1',
        teal: '#14b8a6',
        orange: '#f97316',
        cyan: '#06b6d4'
    },
    teeth_sides: [0, 1, 2, 3, 4],
    logo: toothlens_logo
}

const nexus = {
    colors: {
        primary: '#000000',
        secondary: '#6b7280',
        tertiary: '#1f2937',
        accent: '#374151',
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6',
        light: '#f9fafb',
        dark: '#111827',
        purple: '#8b5cf6',
        pink: '#ec4899',
        indigo: '#6366f1',
        teal: '#14b8a6',
        orange: '#f97316',
        cyan: '#06b6d4'
    },
    teeth_sides: [0, 1, 2, 3, 4],
    logo: nexus_logo
}

// Placeholder config: exact photo types/labels/instructions are TBD from the client (PRD §9).
// teeth_sides intentionally uses indices 0-2 (front/left/right) to match the demo-content
// override keys below; see docs/PRD.md §9 for the open question on final photo composition.
const pepsodentGumcheckIndia = {
    colors: {
        primary: '#000000',
        secondary: '#6b7280',
        tertiary: '#1f2937',
        accent: '#374151',
        success: '#10b981',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#3b82f6',
        light: '#f9fafb',
        dark: '#111827',
        purple: '#8b5cf6',
        pink: '#ec4899',
        indigo: '#6366f1',
        teal: '#14b8a6',
        orange: '#f97316',
        cyan: '#06b6d4',
        // FR-28/FR-32: Pantone 334C/185C. Dedicated keys, not colors.success/error -
        // "did this photo pass validation" (a status concept) and "is this button a
        // yes/no action" (a UI-action concept) stay distinct even though they're
        // unrelated today.
        'pepsodent-india-primary': '#009775',
        'pepsodent-india-secondary': '#E4002B'
    },
    // FR-29: licensed Gotham Rounded Bold web font (src/assets/pepsodent-india/Gotham-Rounded-Bold.ttf,
    // @font-face in App.css), replacing the interim Poppins placeholder.
    font: "'gotham-rounded-bold', sans-serif",
    teeth_sides: [0, 1, 2],
    logo: pepsodent_india_logo,
    content: {
        landing: {
            description: "Take the 3-step Pepsodent Gum Scan today & understand your gum health better.",
            buttonText: "Start",
            // FR-14 (v0.21): shown instead of the generic resume banner when every photo
            // step is already captured but the prior submission attempt never succeeded.
            resumeSubmissionFailedMessage: "Your last submission attempt didn't go through. Let's try again - your photos are safely saved."
        },
        demo: {
            front: {
                label: "Front View",
                // Cropped to mouth/teeth only (see ticket 35) so the shared dabur
                // placeholder model's face isn't shown while a client asset is pending.
                image: pepsodentIndiaFrontImage,
                name: "Front placeholder",
                helpers: [
                    "Fit your smile in the frame"
                ]
            },
            left: {
                label: "Side View – Left",
                image: pepsodentIndiaLeftImage,
                name: "Left placeholder",
                helpers: [
                    "Fit your smile in the frame",
                    "Pull your lip back so that your Gums are visible"
                ]
            },
            right: {
                label: "Side View – Right",
                image: pepsodentIndiaRightImage,
                name: "Right placeholder",
                helpers: [
                    "Fit your smile in the frame",
                    "Pull your lip back so that your Gums are visible"
                ]
            }
        },
        // FR-31: shown right after a captured photo passes server-side validation.
        capture: {
            passMessage: "This angle suits you"
        },
        // FR-30: shown while the submitted scan is being analyzed.
        submission: {
            bufferingMessage: "Processing your result...",
            // FR-14 (v0.21): shown once the submission-retry cap is hit - a hard block,
            // no Retry button, unlike FR-25's resend cap.
            limitReachedMessage: "We're unable to process your submission after several attempts. Please check back after some time."
        }
    }
}

const companyConfigs = {
    meswak,
    haleon,
    ryzehealth,
    idealhealth,
    toothlens,
    nexus,
    'pepsodent-gumcheck-india': pepsodentGumcheckIndia
}

export default companyConfigs